import HeaderTabsContainer, { TabButton } from '@/header/HeaderTabsContainer';
import { MY_TICKETS, SAVED_TICKETS } from '@/routing/routes';
import React from 'react';
import useHeaderTabsScroll from '@/_hooks/useHeaderTabsScroll';

function TicketsOverviewTabs({ active }) {
    const scrollElementRef = useHeaderTabsScroll();
    return (
        <HeaderTabsContainer>
            <TabButton
                route={MY_TICKETS}
                i18nCode="jsp.podaneTikety"
                activeRoute={active}
                scrollElementRef={scrollElementRef}
            />
            <TabButton
                route={SAVED_TICKETS}
                i18nCode="menu.ulozeneTikety"
                activeRoute={active}
                scrollElementRef={scrollElementRef}
            />
        </HeaderTabsContainer>
    );
}

export default TicketsOverviewTabs;
